var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWingspanLogoBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 80 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#090706",
  d: "M53.854 0 33.086.065 15.798 30.011 26.143 48zM79.9 0 59.128.065 41.842 30.011 52.185 48zM27.812 0H.1l13.11 24.033z"
})));
export default SvgWingspanLogoBlack;